export default "__VITE_ASSET__BBt0EtAd__"